export default __webpack_public_path__ + "static/media/iitkgplogo.03d41083.png";